// extracted by mini-css-extract-plugin
module.exports = {"container":"ContextMenuItem__container___FLNIE","isActive":"ContextMenuItem__isActive___M1z6c","iconChevron":"ContextMenuItem__iconChevron___PGZs4"};